import React from 'react';
import { withRouter } from 'react-router-dom';
import { get, isEmpty, isNil } from 'lodash';
import queryString from 'query-string';

// local dependencies
import { ActionWidgetItemDetailService } from 'services/actionWidgetItemDetail';
import { actionWidgetItemDetail as ActionWidgetItemDetailView } from 'ui/views/widgets/actionWidgetItemDetail';
import { DASHBOARD } from 'constants/route-paths';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ActionWidgetItemDetail } from 'ui/containers/ActionWidgetItemDetail';
 *
 * // render
 * <ActionWidgetItemDetail propName='propValue'/>
 */
export class _ActionWidgetItemDetail extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.actionWidgetItemDetailService = new ActionWidgetItemDetailService();
        const queryParams = queryString.parse( this.props.location.search );

        this.handleNavActionClick = this.handleNavActionClick.bind( this );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            actionId: get( queryParams, 'actionId' ),
            componentData: undefined,
        };
        
        // if - `actionId` is not present, redirect to the dashboard landing
        // else - make service request for the component data
         if( isEmpty( this.state.actionId ) ) {
            this.props.history.replace( DASHBOARD );
         } else {
            this.fetchComponentData(); // start component data fetch
         }
    }

    /**
	 * @desc Fetch component response.
	 */
    async fetchComponentData() {

        log.debug( 'ActionWidgetItemDetailView.fetchComponentData()' );

        // cancel ongoing request
        this.actionWidgetItemDetailService.cancel();

        const queryParams = queryString.parse( this.props.location.search );

        const reqPayload = {
            data: {},
            context: {
                actionId: this.state.actionId,
            }
        };

        if( ! isNil( get( queryParams, 'origin', null ) ) ) {
            reqPayload.context.module = get( queryParams, 'origin' );
        }

        // get status and service data
        const { status, data } = await this.actionWidgetItemDetailService.fetchComponentData( {
            url: this.props.widget.url,
            data: reqPayload
        } );
        
        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }


    handleNavActionClick( { type, value } ) {
        log.debug( 'ActionWidgetItemDetailView.handleNavActionClick()' );

        if(  'headerAction' === type && 'back' === value.name ) {
            this.props.history.goBack();
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {

        // get origin param
        const queryParams = queryString.parse( this.props.location.search );
        const origin = get( queryParams, 'origin', null );

        return (
            <ActionWidgetItemDetailView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                actionId={ this.state.actionId }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload = { {
                    context: {
                        actionId: this.state.actionId,
                        module: origin,
                    }
                } }
                onNavActionClick={ this.handleNavActionClick }
            />
        );
    }
}

// set display name
_ActionWidgetItemDetail.displayName = '_ActionWidgetItemDetail';

// set default props
_ActionWidgetItemDetail.defaultProps = {};

// prop types
_ActionWidgetItemDetail.propTypes = {};

export const ActionWidgetItemDetail = withRouter( _ActionWidgetItemDetail );
